import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-header" }
const _hoisted_2 = { class: "header-content" }
const _hoisted_3 = { class: "nav" }
const _hoisted_4 = { class: "cart-section desktop-only" }
const _hoisted_5 = {
  key: 0,
  class: "bet-count"
}
const _hoisted_6 = { class: "mobile-actions mobile-only" }
const _hoisted_7 = {
  key: 0,
  class: "bet-count"
}

import { onMounted, computed } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from '../../stores/auth'
import { useBetslipStore } from '../../stores/betslip'
import { useModalStore } from '../../stores/modal'
import { useTheme } from '../../composables/useTheme'


export default /*@__PURE__*/_defineComponent({
  __name: 'AppHeader',
  setup(__props) {

const route = useRoute()
const authStore = useAuthStore()
const betslipStore = useBetslipStore()
const modalStore = useModalStore()
const { currentTheme } = useTheme()

const betCount = computed(() => betslipStore.betslip?.length || 0)

const isActive = (path: string) => route.path === path

const openBetslip = () => {
  modalStore.openBetslip()
}

const showWagers = computed(() => {
  const hideWhenUnauthenticated = currentTheme.value?.navigation?.hideWagersWhenUnauthenticated
  if (hideWhenUnauthenticated) {
    return authStore.isAuthenticated || authStore.hasValidSession()
  }
  return true
})

onMounted(() => {
  authStore.initializeFromSession()
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("nav", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: { path: '/all', query: _unref(route).query },
          class: _normalizeClass(["nav-link", { active: isActive('/all') }])
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('nav.all')), 1)
          ]),
          _: 1
        }, 8, ["to", "class"]),
        _createVNode(_component_router_link, {
          to: { path: '/next-draws', query: _unref(route).query },
          class: _normalizeClass(["nav-link", { active: isActive('/next-draws') }])
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('nav.nextDraws')), 1)
          ]),
          _: 1
        }, 8, ["to", "class"]),
        (showWagers.value)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: { path: '/wagers', query: _unref(route).query },
              class: _normalizeClass(["nav-link", { active: isActive('/wagers') }])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('nav.wagers')), 1)
              ]),
              _: 1
            }, 8, ["to", "class"]))
          : _createCommentVNode("", true),
        _createVNode(_component_router_link, {
          to: { path: '/results', query: _unref(route).query },
          class: _normalizeClass(["nav-link", { active: isActive('/results') }])
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('nav.results')), 1)
          ]),
          _: 1
        }, 8, ["to", "class"]),
        _createVNode(_component_router_link, {
          to: { path: '/how-to-play', query: _unref(route).query },
          class: _normalizeClass(["nav-link", { active: isActive('/how-to-play') }])
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('nav.howToPlay')), 1)
          ]),
          _: 1
        }, 8, ["to", "class"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "cart-icon",
          onClick: openBetslip
        }, [
          _cache[0] || (_cache[0] = _createElementVNode("img", {
            src: "/img/icons/cart.svg",
            alt: "Cart",
            class: "cart-svg"
          }, null, -1)),
          (betCount.value > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(betCount.value), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: "cart-icon",
          onClick: openBetslip
        }, [
          _cache[1] || (_cache[1] = _createElementVNode("img", {
            src: "/img/icons/cart.svg",
            alt: "Cart",
            class: "cart-svg"
          }, null, -1)),
          (betCount.value > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(betCount.value), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})